import { render, staticRenderFns } from "./PublicSeaClueAssign.vue?vue&type=template&id=062c44e8&scoped=true"
import script from "./PublicSeaClueAssign.vue?vue&type=script&lang=js"
export * from "./PublicSeaClueAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062c44e8",
  null
  
)

export default component.exports